import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "./Navbar";
import { FaInfoCircle } from "react-icons/fa";
import { FaRegBell } from "react-icons/fa6";
import HelpModal from "../common/modals/HelpModal";
import { httpReauest } from "../../utils/httpRequest";

const Layout = ({ children, home, admin }) => {
  const [show, setShow] = useState(false);
  const [notifOpen, setNotifOpen] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const location = useLocation();

  useEffect(() => {
    fetchNotifications();
  }, [location.pathname]);

  const fetchNotifications = async () => {
    try {
      const user = JSON.parse(localStorage.getItem("user"));
      if (!user) return;

      const res = await httpReauest(
        "GET",
        `/user/notifications/${user._id}`,
        {},
        {}
      );
      const result = res.data;
      setNotifications(result.data || []);
    } catch (err) {
      console.error("Failed to load notifications:", err.message);
    }
  };

  const markAsRead = async (notifId) => {
    try {
      await httpReauest("POST", `/user/notification/read`, { notifId }, {});

      // حذف نوتیف از لیست یا بروزرسانی به حالت خوانده‌شده
      setNotifications((prev) =>
        prev.map((n) => (n._id === notifId ? { ...n, read: true } : n))
      );
    } catch (err) {
      console.error("Error marking as read:", err.message);
    }
  };

  return (
    <>
      <div className="flex relative overflow-x-hidden w-full min-h-[90vh]">
        <span className="lg:min-w-[290px] min-w-0 lg:w-fit w-0">
          <Navbar
            notifOpen={notifOpen}
            notifications={notifications}
            setNotifOpen={setNotifOpen}
            admin={admin}
            markAsRead={markAsRead}
          />
        </span>
        <span className="w-full lg:w-full p-3 lg:p-8 mt-10 lg:mt-0">
          {show && <HelpModal show={show} setShow={setShow} />}
          <div className="lg:flex justify-end hidden gap-3 relative">
            {/* Bell icon */}
            <button
              onClick={() => setNotifOpen((prev) => !prev)}
              className="px-3 relative rounded-full flex gap-2 text-white items-center transition-all duration-200 text-xl font-semibold"
            >
              <FaRegBell />
              {notifications.some((n) => !n.read) && (
                <span className="absolute w-4 h-4 flex items-center justify-center top-0 right-0 bg-red-500 text-white text-[10px] px-1 rounded-full">
                  {notifications.filter((n) => !n.read).length}
                </span>
              )}
            </button>

            {/* Notification dropdown */}
            {notifOpen && (
              <div className="absolute right-0 top-10 w-[300px] max-h-[350px] overflow-auto text-white rounded shadow-lg z-50">
                {notifications.length === 0 ? (
                  <div className="p-4 text-center text-gray-500 bg-[#1E2B3B]">
                    No Notification
                  </div>
                ) : (
                  <ul>
                    {notifications.map((n) => (
                      <li
                        key={n._id}
                        className={`border-b border-gray-900 p-3 ${
                          !n.read ? "bg-[#4b5c70]" : "bg-[#1E2B3B]"
                        }`}
                      >
                        <div className="font-semibold">{n.title}</div>
                        <div className="text-sm mb-2">{n.message}</div>
                        {!n.read && (
                          <button
                            onClick={() => markAsRead(n._id)}
                            className="text-red-600 text-sm font-bold hover:underline"
                          >
                            check as read
                          </button>
                        )}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            )}

            {/* Help button */}
            <button
              onClick={() => setShow(true)}
              className="px-6 py-2 rounded-full flex gap-2 bg-indigo-600 text-white items-center hover:bg-indigo-700 shadow-lg transition-all duration-200 text-sm font-semibold"
            >
              Help
            </button>
          </div>

          {/* Floating help button for mobile */}
          <button
            onClick={() => setShow(true)}
            className="fixed left-2 bottom-2 lg:hidden justify-center z-50 rounded-full bg-white/50 shadow-lg flex gap-2 text-white items-center transition-all duration-200 text-sm font-semibold"
          >
            <FaInfoCircle
              className="text-indigo-600 cursor-pointer"
              title="Help"
              size={42}
            />
          </button>

          {children}

          <div className="text-center text-white">
            © 2025, FileTrust. All Rights Reserved
          </div>
        </span>
      </div>
    </>
  );
};

export default Layout;
